import React, {ReactElement} from 'react';
import {Rewardslogo} from './Rewardslogo';
import {setAppBarTitle, setBackNavEnabled} from '../../redux/globalSlice';
import {useAppDispatch, useAppSelector} from '../../redux/hooks';
import {useEffect} from 'react';
import {Rewardspoints} from './Rewardspoints';
import {Rewardscontent} from './Rewardscontent';
import {setPageName} from '../../lib/tagmanager';
import {pageName} from '../../lib/constants';
import { Sbipoints } from './Sbipoints';

const LMRrewards = (): ReactElement => {
  useEffect(() => {
    dispatch(setAppBarTitle('Landmark Rewards'));
    dispatch(setBackNavEnabled(true));
    return () => {
      // Clean up the subscription
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
    };
  }, [setAppBarTitle]);
  useEffect(() => {
    setPageName(pageName.rewardPage);
  }, []);
  const dispatch = useAppDispatch();
  return (
    <div>
      <Rewardslogo />
      <Rewardspoints />
      <Rewardscontent />
      <Sbipoints/>
    </div>
  );
};

export default LMRrewards;
